"use strict";var e=require("../Coerce/enumeration.cjs").enumeration({Ads:"ADS",Core:"COR",KeyMoments:"KM",Mercury:"MER",FanZone:"FNZ",Solutions:"SOL",Switcher:"SWH",UI:"UI"});exports.PackageNamespace=e;
//# sourceMappingURL=PackageNamespace.cjs.map
